<p class="progress-stepper-title helvetica-neue-regular-font mb-15 vo-heading-regular-18"> {{ referenceDataLabels.ThisStepContains | localizeLabel }} </p>
<div class="progress-stepper-wrapper">
    <ng-container *ngIf="activeTab?.key === 'yourMortgage'">
        <boi-progress-stepper-item *ngIf="sections?.YourMortgage.AboutYourMortgage as status"
            [stepTitle]="referenceDataLabels.AboutTheMortgageId" [status]="status"
            [hasSubmitValidationError]="hasSubmitValidationError">
        </boi-progress-stepper-item>
        <boi-progress-stepper-item *ngIf="sections?.YourMortgage.AboutTheFees as status"
            [stepTitle]="referenceDataLabels.AboutTheFeesId" [status]="status"
            [hasSubmitValidationError]="hasSubmitValidationError">
        </boi-progress-stepper-item>
    </ng-container>

    <ng-container *ngIf="activeTab?.key === 'applicant' && sections?.Applicant[activeTab.index]">
        <boi-progress-stepper-item *ngIf="sections?.Applicant[activeTab.index].AboutYou as status"
            [stepTitle]="referenceDataLabels.AboutYouId" [status]="status"
            [hasSubmitValidationError]="hasSubmitValidationError">
        </boi-progress-stepper-item>
        <boi-progress-stepper-item *ngIf="sections?.Applicant[activeTab.index].PlacesYouveLived as status"
            [stepTitle]="referenceDataLabels.PlacesYouHaveLived" [status]="status"
            [hasSubmitValidationError]="hasSubmitValidationError">
        </boi-progress-stepper-item>
        <boi-progress-stepper-item *ngIf="sections?.Applicant[activeTab.index].YourIncome as status"
            [stepTitle]="referenceDataLabels.YourIncomeId" [status]="status"
            [hasSubmitValidationError]="hasSubmitValidationError">
        </boi-progress-stepper-item>
        <boi-progress-stepper-item *ngIf="sections?.Applicant[activeTab.index].YourCurrentProperties as status"
            [stepTitle]="referenceDataLabels.YourProperties" [status]="status"
            [hasSubmitValidationError]="hasSubmitValidationError">
        </boi-progress-stepper-item>
    </ng-container>

    <ng-container *ngIf="activeTab?.key === 'applicant' && !sections?.Applicant[activeTab.index]">
        <boi-progress-stepper-item [stepTitle]="referenceDataLabels.AboutYouId" [status]="{IsComplete: false}"
            [hasSubmitValidationError]="hasSubmitValidationError">
        </boi-progress-stepper-item>
        <boi-progress-stepper-item [stepTitle]="referenceDataLabels.PlacesYouHaveLived" [status]="{IsComplete: false}"
            [hasSubmitValidationError]="hasSubmitValidationError">
        </boi-progress-stepper-item>
        <boi-progress-stepper-item [stepTitle]="referenceDataLabels.YourIncomeId" [status]="{IsComplete: false}"
            [hasSubmitValidationError]="hasSubmitValidationError">
        </boi-progress-stepper-item>
        <boi-progress-stepper-item [stepTitle]="referenceDataLabels.YourProperties" [status]="{IsComplete: false}"
            [hasSubmitValidationError]="hasSubmitValidationError">
        </boi-progress-stepper-item>
    </ng-container>


    <ng-container *ngIf="activeTab?.key === 'yourOutgoings'">
        <boi-progress-stepper-item *ngIf="sections?.YourOutgoings.AboutYourOutgoings as status"
            [stepTitle]="referenceDataLabels.SectionTitleOutgoings" [status]="status"
            [hasSubmitValidationError]="hasSubmitValidationError">
        </boi-progress-stepper-item>
        <boi-progress-stepper-item *ngIf="sections?.YourOutgoings.Declaration as status"
            [stepTitle]="referenceDataLabels.SectionTitleDeclaration" [status]="status"
            [hasSubmitValidationError]="hasSubmitValidationError">
        </boi-progress-stepper-item>
    </ng-container>

    <ng-container *ngIf="activeTab?.key === 'yourProperty'">
        <boi-progress-stepper-item *ngIf="sections?.YourProperty.AboutTheProperty as status"
            [stepTitle]="referenceDataLabels.AboutProperty" [status]="status"
            [hasSubmitValidationError]="hasSubmitValidationError">
        </boi-progress-stepper-item>
        <boi-progress-stepper-item *ngIf="sections?.YourProperty.PropertyContacts as status"
            [stepTitle]="referenceDataLabels.PropertyContacts" [status]="status"
            [hasSubmitValidationError]="hasSubmitValidationError">
        </boi-progress-stepper-item>
        <boi-progress-stepper-item *ngIf="sections?.YourProperty.LegalSupport as status"
            [stepTitle]="referenceDataLabels.LegalSupport" [status]="status"
            [hasSubmitValidationError]="hasSubmitValidationError">
        </boi-progress-stepper-item>
        <boi-progress-stepper-item *ngIf="sections?.YourProperty.AnyAdditionalInfo as status"
            [stepTitle]="referenceDataLabels.AnyAdditionalInformation" [status]="status"
            [hasSubmitValidationError]="hasSubmitValidationError">
        </boi-progress-stepper-item>
    </ng-container>

    <ng-container *ngIf="activeTab?.key === 'factFind2'">
        <boi-progress-stepper-item *ngIf="sections?.FactFind2.OtherDetails as status"
            [stepTitle]="referenceDataLabels.FactFind2OtherDetails" [status]="status"
            [hasSubmitValidationError]="hasSubmitValidationError">
        </boi-progress-stepper-item>
        <boi-progress-stepper-item *ngIf="sections?.FactFind2.Fees as status"
            [stepTitle]="referenceDataLabels.AboutTheFeesId" [status]="status"
            [hasSubmitValidationError]="hasSubmitValidationError">
        </boi-progress-stepper-item>
    </ng-container>

</div>
